module.exports = __webpack_public_path__ + "static/media/middle-school-coding.ae3d4d3c.webp";